// @ts-nocheck
/**
 * @typedef { '--primary-pink-hex' |
 * '--primary-pink-hex-light2' |
 * '--primary-pink-hex-light3' |
 *  '--primary-pink-rgb' |
 *  '--primary-pink-rgb-light' |
 *  '--primary-pink-rgb-light2' |
 *  '--red-shade-1-hex' |
 *  '--red-shade-1rgb' |
 *  '--event-form-max-width' |
 *  '--disabled-white-rgba' |
 *  '--light-grey-1-rgb' |
 *  '--light-grey-2-hex' |
 *  '--light-grey-2-rgb' |
 *  '--bg-dark-grey-1-hex' |
 *  '--bg-dark-grey-1-rgb' |
 *  '--bg-dark-grey-2-hex' |
 *  '--bg-dark-grey-2-rgb' |
 *  '--bg-theme-rgb' |
 *  '--back-shade-2-hex' |
 *  '--black-shade-2-rgb' |
 *  '--black-shade-2-hex' |
 *  '--black-shade-2-rgb' |
 *  '--font-rgb' |
 *  '--white-rgb' |
 *  '--primary-green-hex' |
 *  '--primary-green-rgb' |
 *  '--primary-green-shade2-hex' |
 *  '--primary-green-shade2-rgb' |
 *  '--primary-green-text-hex' |
 *  '--primary-green-text-rgb' |
 *  '--primary-red-hex' |
 *  '--primary-red-rgb' |
 *  '--primary-blue-hex' |
 *  '--primary-blue-rgb' |
 *  '--primary-blue-shade2-hex' |
 *  '--primary-blue-shade2-rgb' |
 *  '--dark-blue-1-hex' |
 *  '--dark-blue-1-rgb' |
 *  '--primary-yellow-hex' |
 *  '--primary-yellow-dark-hex' |
 *  '--gusto-orange-color' |
 *  '--showphaze-cyan-color' |
 *  '--showphaze-violet-color' |
 *  '--rate-list-yellow' |
 *  '--backup-position-color' |
 *  '--softer-orange-color'
 * } CssVariableName
 */

/**
 * Get the value of a CSS variable
 *
 * @param {Object} params
 * @param {CssVariableName} params.variableName
 * @returns {string} The value of the CSS variable.
 */
const getCssVariableHandler = ({ variableName }) => {
  return window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(variableName);
};

const getRGBAFromRGBGivenAlphaHandler = ({ alpha, rgb }) => {
  let new_col;
  new_col = rgb.replace(/rgb/i, "rgba");
  return new_col.replace(/\)/i, `, ${alpha})`);
};

export { getCssVariableHandler, getRGBAFromRGBGivenAlphaHandler };